import { FC, ReactElement, SVGProps } from "react";

export const UnderdotsLogo: FC<{
  className?: string;
  wordFill?: "#a6e200" | "#fff" | "#000";
}> = ({
  className,
  wordFill = "#fff"
}): ReactElement<SVGProps<SVGSVGElement>> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1009.98 141.73"
    display="block"
    className={className ?? ""}
  >
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m134.86,73.89v-41.8h18.04v40.39c0,13.72,6.37,22.57,22.36,22.57s22.25-8.86,22.25-22.57v-40.39h18.04v41.8c0,22.46-13.39,36.94-40.28,36.94s-40.39-14.47-40.39-36.94Z"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m315.87,109.64h-15.88l-48.38-54.54v54.54h-17.5V32.09h18.25l46.01,51.95v-51.95h17.5v77.55Z"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m336.28,32.09h40.18c27.54,0,44.82,15.12,44.82,38.77s-17.28,38.77-44.82,38.77h-40.18V32.09Zm40.18,62.32c16.85,0,26.68-9.29,26.68-23.54s-9.83-23.54-26.78-23.54h-22.36v47.09h22.46Z"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m631.42,32.09h40.18c27.54,0,44.82,15.12,44.82,38.77s-17.28,38.77-44.82,38.77h-40.18V32.09Zm40.18,62.32c16.85,0,26.68-9.29,26.68-23.54s-9.83-23.54-26.78-23.54h-22.36v47.09h22.46Z"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m822.08,70.87c0,23.11-19.33,39.96-46.01,39.96s-46.12-16.85-46.12-39.96,19.33-39.96,46.12-39.96,46.01,16.85,46.01,39.96Zm-73.77,0c0,14.69,11.56,24.3,27.76,24.3s27.65-9.61,27.65-24.3-11.56-24.3-27.65-24.3-27.76,9.61-27.76,24.3Z"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m880.58,47.54v62.1h-18.04v-62.1h-33.7v-15.44h85.32v15.44h-33.59Z"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m929.48,81.45c9.07,10.69,22.9,14.26,34.13,14.26,11.99,0,20.41-3.24,20.41-8.86,0-6.48-6.37-7.02-27.11-9.29-18.47-2.05-33.37-5.83-33.37-21.38s14.8-25.27,37.26-25.27c17.5,0,33.05,5.83,40.39,14.36l-11.34,11.99c-6.16-7.13-17.39-11.34-30.24-11.34s-18.36,3.67-18.36,8.32c0,5.08,5.4,6.16,24.52,8.32,20.3,2.27,36.94,5.4,36.94,22.36s-17.06,25.92-39.85,25.92c-17.82,0-36.94-6.37-44.71-16.31l11.34-13.07Z"
    />
    <polygon
      strokeWidth="0"
      fill={wordFill}
      points="438.63 109.64 513.8 109.64 513.8 94.19 456.34 94.19 456.34 77.67 513.8 77.67 513.8 62.44 456.34 62.44 456.34 47.54 513.8 47.54 513.8 32.09 438.63 32.09 438.63 109.64"
    />
    <path
      strokeWidth="0"
      fill={wordFill}
      d="m612.22,100.15l-16.58-19.89c10.91-3.46,17.5-11.56,17.5-23.22,0-16.2-12.09-24.95-30.13-24.95h-49.36v77.54h18.04v-27.54h24.8l23.27,27.54h12.46v-9.49Zm-30.19-32.74h-30.35v-20.09h30.35c8.53,0,13.39,3.67,13.39,10.04s-4.86,10.04-13.39,10.04Z"
    />
    <path
      fill="#a6e200"
      d="m74.18,50.56c.56,2.44.86,4.98.86,7.58,0,18.71-15.17,33.88-33.88,33.88-2.61,0-5.14-.3-7.58-.86,3.45,15.06,16.92,26.3,33.02,26.3,18.71,0,33.88-15.17,33.88-33.88,0-16.1-11.24-29.57-26.3-33.02Z"
    />
    <path
      fill="#a6e200"
      d="m66.6,49.7c2.61,0,5.14.3,7.58.86-3.45-15.06-16.92-26.3-33.02-26.3-18.71,0-33.88,15.17-33.88,33.88,0,16.1,11.24,29.57,26.3,33.02-.56-2.44-.86-4.98-.86-7.58,0-18.71,15.17-33.88,33.88-33.88Z"
    />
  </svg>
);
